export default "__VITE_ASSET__uFOrGPBO__"